import './AccessDenied.css'
import imageURL from 'assets/img/ES_401-Error_Graphic.svg'
import { EuiSpacer, EuiText } from '@equipmentshare/ds2'

export default function AccessDenied() {
	return (
		<div id="access-denied-container" className="outer">
			<div className="inner">
				<img src={imageURL} alt="Access Denied" />
				<EuiSpacer size="xl" />
				<EuiText>
					<h3><strong>You do not have access to this application.</strong></h3>
				</EuiText>
				<EuiText>
          			Contact our support for more information.
				</EuiText>
			</div>
		</div>
	)
}
